import React from 'react';
import { type RouteObject } from 'react-router-dom';

import PageRegister from './index';

/**
 * `/register` route for the magic-link sign-up page.
 *
 * Like `/login` and the configurator wizard, this is a full-bleed experience that
 * owns the whole viewport and brings its own backdrop, so it is mounted as a
 * standalone route (NOT through the account-chrome layouts in `router.tsx`) and is
 * NOT auth-gated: it is the screen the auth gate (`useAuthGate`) sends an
 * unauthenticated visitor to. `src/routes.tsx` prepends it before the
 * config-driven routes so it wins the specificity tie against the remote config's
 * `/register` page.
 */
export const registerRoute: RouteObject = {
  path: '/register',
  element: <PageRegister />,
};

export default registerRoute;
